import { Component, Input, EventEmitter, Output } from '@angular/core';

// Usage
// <lib-toggle-switch
//   [checked]="false"
//   (searchChanged)="changed($event)"
// ></lib-toggle-switch>
@Component({
  selector: 'lib-toggle-switch',
  styleUrls: ['toggle-switch.component.scss'],
  templateUrl: 'toggle-switch.component.html',
})
export class ToggleSwitchComponent {
  @Input() checked!: boolean;
  @Input() label!: string;
  @Input() disabled!: boolean;
  @Output() changed = new EventEmitter<boolean>();

  changeHandler(e: any) {
    this.changed.emit(e.target.checked);
  }
}
